import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { WebEnvironmentService } from '@degreed/lxp/services';
import { AuthService } from '@degreed/lxp/services/authorization';

const AllowedOrgId = {
  Production: 1,
  Release: 1,
  Beta: 1,
};

// In non-production environments any org can access proto routes
const OpenEnvironments = new Set(['Local', 'LocalStaging', 'Staging']);

@Injectable()
export class ProtoGuardService {
  private webEnvironmentService = inject(WebEnvironmentService);
  private router = inject(Router);
  private authService = inject(AuthService);

  public canActivate() {
    return this.checkOrgMembership();
  }

  public canLoad(): boolean {
    return this.checkOrgMembership();
  }

  private checkOrgMembership(): boolean {
    if (OpenEnvironments.has(this.webEnvironmentService.environment)) {
      return true;
    }

    let isAllowed = false;
    const orgId = AllowedOrgId[this.webEnvironmentService.environment];

    if (orgId) {
      const userOrgs: number[] = this.authService.authUser.orgInfo.map(
        (org) => org.organizationId
      );
      isAllowed = userOrgs.includes(orgId);
    }

    if (!isAllowed) {
      this.router.navigate(['/error']);
    }

    return isAllowed;
  }
}
